import React, { useState, useEffect } from 'react';
import useStyles from './styles';

import Loading from '../../components/Loading'
import Modal from '../../components/Modal'

import api from '../../services/api';
import { useParams, useHistory } from 'react-router';

function ActivateAccount() {
  const c = useStyles();
  const {uuid} = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [alertModal, setAlertModal] = useState(null);



  useEffect(() => {
    setLoading(true);
    if (uuid) {
      api().post(`/user/activate/${uuid}`)
      .then(result => {
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        // Show message on error
        if (err?.response?.data?.msg) {
          setAlertModal(err.response.data.msg);
        }
        else {
        }
        history.push('/')
      })
    }
  }, [])

  return (
    <>
    {loading && <Loading className={c.loading}/>}
    {!loading && (
      <div className={c.container}>
        <h1>Account successfully activated</h1>
        <a href="/">Click here to login</a>
      </div>
    )}
      <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
      </Modal>
    </>
  );
}

export default ActivateAccount;